import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { PHP } from '../utils/axiosConfig';

const ProtectedRoute = ({ children, userLevel = 'client' }) => {
	const php = PHP();
	const { isAuthenticated, setShowLogin, user, login, logout } = useAuth();

	useEffect(() => {
		if (!user && sessionStorage.getItem('user')) {
			//User is still in session, but not in context (page was refreshed)
			//Attempt to reload the user from the server
			php
				.get('user.php', { params: { route: 'refresh_user' } })
				.then((res) => {
					console.log(res);
					if (res.status === 200) {
						login(res.data.user);
					}
				})
				.catch((err) => {
					console.log(err);
					logout();
				});
		}
		//If the user is not authenticated, send to home page with Login prompt
		if (!isAuthenticated()) setShowLogin(true);
	});

	useEffect(() => {
		if (user) {
			//If Protected Route is for Admin only
			if (userLevel === 'admin' && user.userlevel !== 'admin') {
				logout();
			}
		}
	}, [user]);

	return isAuthenticated() ? children : <Navigate to="/" />;
};
export default ProtectedRoute;
